"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountAcceptFlowSecuredByQwilrBtn = exports.acceptFlowMarketingParams = void 0;
var react_1 = __importDefault(require("react"));
var SecuredByQwilr_1 = require("@CommonFrontend/SecuredByQwilr/SecuredByQwilr");
exports.acceptFlowMarketingParams = "utm_source=qwilr-branding&utm_medium=qwilr-accept-flow&utm_campaign=powered-by-qwilr";
var mountAcceptFlowSecuredByQwilrBtn = function (mountReactComponent) {
    return mountReactComponent(react_1.default.createElement(SecuredByQwilr_1.SecuredByQwilr, { utmParams: exports.acceptFlowMarketingParams }));
};
exports.mountAcceptFlowSecuredByQwilrBtn = mountAcceptFlowSecuredByQwilrBtn;
